/* eslint-disable @typescript-eslint/camelcase */
import { ConvertObjectCamelToSnakeCase } from "@/app/infrastructures/misc/Utils";
import { QueryParamsEntities2 } from "./MainApp";
import { PaginationV2 } from "./Pagination";

export class DispatchStt {
  ddId = 0;
  ddSttNo = "";
  ddProductType = "";
  ddDestinationCityId = "";
  ddDestinationDistrictId = "";
  ddDestinationDistrictName = "";
  ddDestinationUrsaCode = "";
  ddRefNo = "";
  ddDemNo = "";
  ddPieces = 0;
  ddGrossWeight = 0;
  ddRecipientName = "";
  ddRecipientPhone = "";
  ddRecipientAddress = "";
  ddLastStatus = "";
  ddScanStatus = "";
  ddIsCod = false;
  ddIsDfod = false;

  constructor(fields?: Partial<DispatchStt>) {
    Object.assign(this, fields);
  }
}

export class Dispatch {
  dispatchId = 0;
  dispatchNo = "";
  dispatchStts = 0;
  dispatchSttPieces = 0;
  dispatchSttGrossWeights = 0;
  dispatchSttsFailed = 0;
  dispatchSttPiecesFailed = 0;
  dispatchSttGrossWeightsFailed = 0;
  dispatchCreatedAt = "";
  dispatchCreatedByName = "";
  dispatchCreatedByRole = "";
  dispatchToDriverId = 0;
  dispatchToDriverName = "";
  dispatchToDriverPhone = "";
  dispatchToHubId = 45;
  dispatchToHubName = "";
  dispatchToCityCode = "";
  dispatchToShuttleId = 0;
  dispatchToShuttleName = "";
  stts: DispatchStt[] = [];

  constructor(fields?: Partial<Dispatch>) {
    Object.assign(this, fields);
  }
}

export class DispatchEntities {
  pagination = new PaginationV2();
  data: Dispatch[] = [];

  constructor(fields?: Partial<DispatchEntities>) {
    Object.assign(this, fields);
  }
}

export class DispatchListRequest {
  dispatchNo = "";
  startDate = "";
  endDate = "";
  createdType = "";
  page = 1;
  limit = 10;

  constructor(fields?: Partial<DispatchListRequest>) {
    Object.assign(this, fields);
  }

  toQueryString(): string {
    return new QueryParamsEntities2(ConvertObjectCamelToSnakeCase(this))
      .queryString;
  }
}
export class UpdateDispatchStt {
  sttId = 0;
  sttNo = "";
  sttProductType = "";
  sttTotalPiece = 0;
  sttDestinationCityId = "";
  sttDestinationCityName = "";
  sttDestinationDistrictId = "";
  sttDestinationDistrictName = "";
  sttDestinationDistrictUrsaCode = "";
  sttCommodityCode = "";
  sttCommodityName = "";
  refNo = "";
  demNo = "";
  sttGrossWeight = 0;
  sttRecipientName = "";
  sttRecipientPhone = "";
  sttRecipientAddress = "";
  sttCodAmount = 0;
  sttLastStatusId = "";
  dtScanStatus = "";
  dtCreatedAt = "";
  dtUpdatedAt = "";
  dtScanNo = "";

  constructor(fields?: Partial<UpdateDispatchStt>) {
    Object.assign(this, fields);
  }
}

export class UpdateDispatch {
  stt: UpdateDispatchStt = new UpdateDispatchStt();
  demStatus = "";
  dtDemTotal = 0;
  dtDemTotalNow = 0;
  dem: UpdateDispatchStt[] = [];

  constructor(fields?: Partial<UpdateDispatch>) {
    Object.assign(this, fields);
  }
}

export class DispatchTemporary {
  dtId = 0;
  dtAccountId = 0;
  dtIsActive = false;
  dtSttNo = "";
  dtProductType = "";
  dtDestinationCityId = "";
  dtDestinationDistrictId = "";
  dtDestinationDistrictName = "";
  dtDestinationDistrictUrsaCode = "";
  dtRefNo = "";
  dtDemNo = "";
  dtPieces = 0;
  dtChargeableWeight = 0;
  dtScanStatus = "";
  dtMeta = {};
  dtCreatedAt = "";
  dtUpdatedAt = "";
  dtDemStatus = "";
  dtScanNo = "";
  sttLastStatusId = "";
  dtRecipientName = "";
  dtRecipientPhone = "";
  dtRecipientAddress = "";
  dtDemTotal = 0;
  dtDemTotalNow = 0;

  constructor(fields?: Partial<DispatchTemporary>) {
    Object.assign(this, fields);
  }

  get sttErrorMessage(): string {
    if (this?.dtScanStatus && this?.dtScanStatus !== "success") {
      const failedScan = {
        failed_unpaid: "Belum bayar",
        failed_destination: "Kota tujuan tidak sesuai",
        "failed_IN-HUB": "Status belum In Hub"
      };

      return (
        failedScan[this?.dtScanStatus as keyof typeof failedScan] ||
        `Status tidak sesuai (${this?.sttLastStatusId})`
      );
    }

    return "";
  }
}
